/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateRead.defs'
export { main as default } from './updateRead.defs'
